import { render, staticRenderFns } from "./Checkerboard.vue?vue&type=template&id=c28701bc&"
import script from "./Checkerboard.vue?vue&type=script&lang=js&"
export * from "./Checkerboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports